import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ProcessesStructuresUnix = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Processes: Structures (PCB, Ready List etc.), Process Creation, Management in Unix"
    videos={[
      "https://www.youtube.com/embed/udOPPbQhASg",
      "https://www.youtube.com/embed/clYXGBVuEgE",
      "https://www.youtube.com/embed/IFEFVXvjiHY",
      "https://www.youtube.com/embed/W8vM3Qn-1aM"
    ]}
    takeaways={[
      { text: "Learn about zombie processes and orphan processes; fork system call is important; remaining topics as outlined in syllabus." }
    ]}
    questions={[
      "State the use of PCB. How is PCB related to context switch? Illustrate the context switch with a neat sketch.",
      "Including the initial parent process, how many processes are created by the program shown below? Justify your answer with an explanation.",
      `#include <stdio.h>\n#include <unistd.h>\nint main()\n{\nif (fork()) {\nif (fork()) {\nfork();\nprintf("1");\n} else {\nprintf("2");\n}\n} else {\nprintf("3");\n}\nprintf("4");\nreturn 0;\n}`
    ]}
    exampleVideos={[]}
  />
);
}

export default ProcessesStructuresUnix;
